/**
 * Screen Wake Lock — keep the display awake for an unattended installation.
 * Re-acquires automatically when the tab returns to the foreground (the lock
 * is released by the browser on visibility loss).
 */
export class WakeLock {
  private sentinel: WakeLockSentinel | null = null;
  private readonly onVisibility: () => void;

  constructor() {
    this.onVisibility = () => {
      if (document.visibilityState === 'visible') void this.request();
    };
  }

  async request(): Promise<void> {
    if (!('wakeLock' in navigator)) return;
    try {
      this.sentinel = await navigator.wakeLock.request('screen');
      document.addEventListener('visibilitychange', this.onVisibility);
    } catch {
      // Denied (e.g. low battery) — non-fatal for the sketches.
    }
  }

  async release(): Promise<void> {
    document.removeEventListener('visibilitychange', this.onVisibility);
    try {
      await this.sentinel?.release();
    } catch {
      /* ignore */
    }
    this.sentinel = null;
  }
}
